export default function getResource(label, vars = []) {
    const resources = {
        reviewsLabel: `${vars[0]}`,
        writeReview: 'Write a review',
        writeReviewCapitalized: 'Write a Review',
        ratingsReviews: 'Reviews Summary',
        seeAllReviews: 'See all reviews',
        closeButton: 'Close'
    };
    return resources[label];
}
